import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'kt-confirm-entity-with-input',
	templateUrl: './confirm-entity-with-input.component.html',
	styleUrls: ['./confirm-entity-with-input.component.scss']
})
export class ConfirmEntityWithInputComponent implements OnInit {

	viewLoading: boolean = false;
	inputValue = new UntypedFormControl('', Validators.required);
	disableOkButton: boolean = true;

	constructor(public dialogRef: MatDialogRef<ConfirmEntityWithInputComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any) { }

	ngOnInit(): void {
		this.inputValue.valueChanges.subscribe(() => {
			this.disableOkButton = this.data.validator(this.inputValue.value);
		});
	}

	onCancelClick(): void {
		this.dialogRef.close();
	}

	onOkClick(): void {
		if (this.inputValue.valid) {
			if (this.data.hideLoading) {
				this.dialogRef.close({ inputValue: this.inputValue.value });
			} else {
				this.viewLoading = true;
				setTimeout(() => {
					this.dialogRef.close({ inputValue: this.inputValue.value });
				}, 2500);
			}
		} else {
			this.inputValue.markAsTouched();
		}
	}
}

